import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'does_the_fac_have_any_of_the_following_safety_measures_in_place_15'

export const dataPointDefinition = {
  retracedId: 'does_the_fac_have_any_of_the_following_safety_measures_in_place_15',
  name: 'Does the facility have any of the following safety measures in place related to storage areas?',
  description: '',
  meta: {},
  fieldTypeId: 'CHECK_BOX',
  type: 'RELATIONAL',
  options: [
    {
      key: 'STORAGE_RACKS_AND_SHELVING_HAS_BEEN_SECURED_TO_PERMANENT_STRUCT',
      text: 'Storage racks and shelving has been secured to permanent structures',
      externalIds: [
        {
          id: 'hs-36--3-1x',
          version: '1.3',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'LIGHTING_IN_STORAGE_AREAS_IS_PROTECTED_OR_EXPLOSION_PROOF',
      text: 'Lighting in storage areas is protected or explosion proof',
      externalIds: [
        {
          id: 'hs-36--3-2x',
          version: '1.3',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'FACILITY_STORAGE_RACKS_HAVE_ADEQUATE_STRENGTH_TO_SUPPORT_EXISTI',
      text: 'Facility storage racks have adequate strength to support existing loads',
      externalIds: [
        {
          id: 'hs-36--3-3x',
          version: '1.3',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'NONE_OF_THE_ABOVE',
      text: 'None of the above',
      externalIds: [
        {
          id: 'hs-36--3-4x',
          version: '1.3',
          provider: 'slcp',
        },
      ],
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'array',
        items: {
          type: 'object',
          properties: {
            key: {
              type: 'string',
              enum: [
                'STORAGE_RACKS_AND_SHELVING_HAS_BEEN_SECURED_TO_PERMANENT_STRUCT',
                'LIGHTING_IN_STORAGE_AREAS_IS_PROTECTED_OR_EXPLOSION_PROOF',
                'FACILITY_STORAGE_RACKS_HAVE_ADEQUATE_STRENGTH_TO_SUPPORT_EXISTI',
                'NONE_OF_THE_ABOVE',
              ],
            },
            isChecked: {
              type: 'boolean',
            },
            followUp: {
              type: ['object', 'null'],
              properties: {
                value: {
                  type: 'string',
                },
              },
              required: ['value'],
            },
          },
          required: ['key', 'isChecked', 'followUp'],
        },
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'hs-mat-1',
      version: '1.4.0',
      provider: 'slcp',
    },
  ],
  sortingId: 16290,
  sectionId: '2.2.9.6',
  impactArea: 'Materials Handling and Storage',
  impactAreaId: 'MATERIALS_HANDLING_AND_STORAGE',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
